import { render, staticRenderFns } from "./RevenueAdd.vue?vue&type=template&id=2ea71ea3"
import script from "./RevenueAdd.vue?vue&type=script&lang=js"
export * from "./RevenueAdd.vue?vue&type=script&lang=js"
import style0 from "./RevenueAdd.vue?vue&type=style&index=0&id=2ea71ea3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports